<template>
  <div ref="root" class="relative">
    <Button variant="stroke" size="md" :icon="SortIcon" @click="open = !open">
      Sort
    </Button>
    <Transition name="popover-down">
      <div
        v-if="open"
        class="absolute left-0 top-[calc(100%+3px)] z-50 w-[240px]"
      >
        <Menu v-model="model" select="single">
          <Menu.Section label="Sort" />
          <Menu.Item
            v-for="option in options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </Menu.Item>
        </Menu>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { Button, Menu } from '@dacr/library'
import { SortIcon } from '@dacr/icons'
import { SearchSort } from '@/shared/graphql/legacy/generated'
import { useEventListener } from '@/shared/composables/useEventListener'

const model = defineModel<SearchSort>({ required: true })

const open = ref(false)
const root = ref<HTMLElement>()

const options = [
  { label: 'Name (A-Z)', value: SearchSort.NameAsc },
  { label: 'Name (Z-A)', value: SearchSort.NameDesc },
  { label: 'Timestamp (Oldest)', value: SearchSort.TimestampAsc },
  { label: 'Timestamp (Newest)', value: SearchSort.TimestampDesc },
]

watch(model, () => (open.value = false))

useEventListener(window, 'click', (event: Event) => {
  if (!root.value?.contains(event.target as Node)) open.value = false
})
</script>
